export default __webpack_public_path__ + "static/media/V460_RoHS.657f469b.pdf";